// Unpublished Work © 2022-2026 Deere & Company.

import accounting from 'accounting';
import {getInventories} from 'Services/membership-service';
import {getCompatibleParts} from 'Services/parts-service';
import {getPartBins} from 'Services/inventory-service';
import {getEquipmentServiceStatus} from 'Services/equipment-service';
import {RECOMMENDED} from 'Common/constants/service-status';
import {alphaNumericCompare} from 'Ui/models/maintenance';
import {capitalizeFirstLetter} from 'Utils/translation-utils';

async function getCompatiblePartsData(equipmentId) {
    const [
        {inventories},
        {compatibleParts}
    ] = await Promise.all([
        getInventories(),
        getCompatibleParts(equipmentId)
    ]);

    const {partBins} = inventories?.length ? await getPartBins(inventories[0].inventoryId) : {};

    return compatibleParts.map((compatiblePart) => {
        const partBin = partBins && partBins.find((partBin) => partBin.partId === compatiblePart.partId);
        const stock = partBin ? accounting.formatNumber(partBin.quantity) : '';

        return {
            ...compatiblePart,
            stock
        };
    });
}

export async function getRowData(equipment) {
    if (equipment?.equipmentId) {
        const {serviceStatus} = await getEquipmentServiceStatus(equipment.equipmentId, RECOMMENDED);

        if (serviceStatus?.length) {
            return getCompatiblePartsData(equipment.equipmentId);
        }
    }

    return [];
}

export function getColumns(translations) {
    return [
        {
            headerName: translations.NAME,
            field: 'partName',
            minWidth: 150,
            flex: 1,
            sortComparator: alphaNumericCompare
        },
        {
            headerName: translations.MANUFACTURER,
            minWidth: 150,
            flex: 1,
            field: 'partManufacturerName'
        },
        {
            headerName: capitalizeFirstLetter(translations.PART_NUMBER),
            minWidth: 150,
            flex: 1,
            field: 'partNumber'
        },
        {
            headerName: translations.TYPE,
            minWidth: 120,
            flex: 1,
            field: 'partType'
        },
        {
            headerName: translations.ONLINK_STOCK,
            field: 'stock',
            type: 'number',
            width: 120,
            renderCell: (params) => {
                return !params.row.stock?.length ? 0 : params.row.stock;
            }
        }
    ];
}
